export default "__VITE_ASSET__99ed0595__"